import { getCurrentUserId, subscribeUserIdentity } from 'auth/userIdentity';
import { RequestCancelledError } from '../apiErrors';

export class AccountChangedError extends RequestCancelledError {
  constructor() {
    super('Account changed during request');
  }
}

// Also detect A -> B -> A while a request is pending.
export async function withOwnerCheck<T>(
  ownerId: string | null,
  read: () => Promise<T>,
): Promise<T> {
  let changed = ownerId !== getCurrentUserId();
  const unsubscribe = subscribeUserIdentity(() => {
    changed ||= ownerId !== getCurrentUserId();
  });
  const check = () => {
    if (changed || ownerId !== getCurrentUserId())
      throw new AccountChangedError();
  };
  try {
    check();
    const result = await read();
    check();
    return result;
  } catch (error) {
    check();
    throw error;
  } finally {
    unsubscribe();
  }
}
